// extracted by mini-css-extract-plugin
export default {"salaryModuleWrap":"styles_salaryModuleWrap__x3UGA"};